module.exports = __webpack_public_path__ + "img/Arrow-Coverage-Dark.3562ce1.svg";